const SharedStructure = {
    rootuser: "", // Unique User ID
    posts: [
      {
        postId: "", // Unique Post ID
        userId: "",
        userName: "",
        useruuid: "",
        userimage: "",
        descriptions: "",
        timestamp: "", // ISO Date-Time String (e.g., "2025-03-03T12:00:00Z")
        sharedOn: "",
        location: "", // Location of the post
        nlikes: 0, // Number of likes
        medias: [
            {
                mediatype: "",
                mediaurl: "",
            }
        ],
      },
    ],
  };
  
  export default SharedStructure;
  